// Core packages
import { NgModule } from "@angular/core";

// Third party packages

// Custom packages - Modules
import { PublicModule } from "src/app/modules/public/public.module";
import { SharedModule } from "../shared.module";
import { SettingsRoutingModule } from "./settings-routing.module";

// Custom packages - Components
import { ActivationEditDialogComponent } from "src/app/modules/settings/components/activation-edit-dialog/activation-edit-dialog.component";
import { ActivationListDialogComponent } from "src/app/modules/settings/components/activation-list-dialog/activation-list-dialog.component";
import { DocumentSettingDetailDialogComponent } from "src/app/modules/settings/components/document-setting-detail-dialog/document-setting-detail-dialog.component";
import { DocumentTemplateDocsDialogComponent } from "src/app/modules/settings/components/document-template-docs-dialog/document-template-docs-dialog.component";
import { DocumentTemplateMoveDialogComponent } from "src/app/modules/settings/components/document-template-move-dialog/document-template-move-dialog.component";
import { StructureSettingDetailDialogComponent } from "src/app/modules/settings/components/structure-setting-detail-dialog/structure-setting-detail-dialog.component";
import { StructureSettingOptionsDialogComponent } from "src/app/modules/settings/components/structure-setting-options-dialog/structure-setting-options-dialog.component";
import { DataTypesComponent } from "src/app/modules/settings/pages/data-types/data-types.page";
import { DocumentDetailComponent } from "src/app/modules/settings/pages/document-detail/document-detail.page";
import { DocumentTemplateComponent } from "src/app/modules/settings/pages/document-template/document-template.page";
import { StructureDetailComponent } from "src/app/modules/settings/pages/structure-detail/structure-detail.page";

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    SettingsRoutingModule,
    PublicModule,
  ],
  declarations: [
    StructureDetailComponent,
    DocumentDetailComponent,
    DocumentTemplateComponent,
    DataTypesComponent,
    DocumentSettingDetailDialogComponent,
    DocumentTemplateDocsDialogComponent,
    DocumentTemplateMoveDialogComponent,
    StructureSettingDetailDialogComponent,
    StructureSettingOptionsDialogComponent,
    ActivationListDialogComponent,
    ActivationEditDialogComponent,
  ],
  entryComponents: [
    DocumentSettingDetailDialogComponent,
    DocumentTemplateDocsDialogComponent,
    DocumentTemplateMoveDialogComponent,
    StructureSettingDetailDialogComponent,
    StructureSettingOptionsDialogComponent,
    ActivationListDialogComponent,
    ActivationEditDialogComponent,
  ],
  exports: [
    DocumentSettingDetailDialogComponent,
    DocumentTemplateDocsDialogComponent,
    DocumentTemplateMoveDialogComponent,
    StructureSettingDetailDialogComponent,
    StructureSettingOptionsDialogComponent,
    ActivationListDialogComponent,
    ActivationEditDialogComponent,
  ],
})
export class SettingsModule {}
